import UPSPICO          from "./upspico.js";

new (class UPS extends UPSPICO {
  constructor(p) {
    super(p);
    this.open();
    this.start();
  }
})();